<template>
  <div class="q-px-sm q-pt-xs">
    <div class="row items-center no-wrap">
      <div
        class="col row q-gutter-xs q-py-xs"
        style="flex-wrap: wrap;"
      >
        <q-chip
          v-for="category in categories"
          :key="`category-${category.id}`"
          removable
          dense
          color="primary"
          text-color="white"
          size="sm"
          @remove="$emit('remove-category', category.id)"
        >
          {{ category.name }}
        </q-chip>

        <q-chip
          v-for="label in labels"
          :key="`label-${label.id}`"
          removable
          dense
          color="primary"
          text-color="white"
          size="sm"
          @remove="$emit('remove', label)"
        >
          {{ label.name }}
        </q-chip>
      </div>
      <q-btn
        size="sm"
        color="grey"
        label="Clear"
        icon="fa fa-times"
        flat
        dense
        no-caps
        @click="$emit('clear')"
      />
    </div>
    <q-separator />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LabelSummary } from '@/analysis/types';

interface CategorySummary {
  id: number;
  name: string;
}

export default defineComponent({
  emits: ['clear', 'remove', 'remove-category'],
  props: {
    labels: {
      type: Array as () => LabelSummary[],
      default: () => [],
    },
    categories: {
      type: Array as () => CategorySummary[],
      default: () => [],
    },
  },
});
</script>
